import { render } from "./NewFooter.vue?vue&type=template&id=94e5b2d4&scoped=true"
import script from "./NewFooter.vue?vue&type=script&lang=js"
export * from "./NewFooter.vue?vue&type=script&lang=js"

import "./NewFooter.vue?vue&type=style&index=0&id=94e5b2d4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94e5b2d4"]])

export default __exports__